import { HttpEventType } from '@angular/common/http';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';

import { CBMError, Contract } from 'app/models';
import { DataProviderType } from 'app/models/enums';
import { ContractService, CsvService } from 'app/services';

interface CBMFileInput {
  field: string;
  accept: string;
  language: string;
}

@Component({
  selector: 'app-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: ['./import-csv.component.scss']
})
export class ImportCsvComponent implements OnInit {
  @ViewChildren('theFileInputs') allFileInputs: QueryList<ElementRef>;

  public contracts: Contract[];
  public errorMessages: CBMError[];
  public isImporting = false;
  public isUploading = false;
  public selectedContractId: string;
  public percentDone: number;

  public csvFileInputs: CBMFileInput[] = [{ field: 'csvFile', accept: '.csv', language: 'IMPORT.SELECTFILE' }];

  constructor(private readonly contractService: ContractService, private readonly csvService: CsvService) {}

  ngOnInit() {
    this.contractService.getContracts().subscribe(
      contracts => {
        this.contracts = contracts ? contracts.filter(c => c.dataproviderType !== DataProviderType.MST) : [];
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  public importCsv() {
    this.isUploading = true;
    this.isImporting = true;
    this.errorMessages = undefined;

    let csvFile: File;
    this.allFileInputs.forEach((fileInput: ElementRef) => {
      const inputEl: HTMLInputElement = fileInput.nativeElement;
      if (inputEl.files.length > 0) {
        csvFile = inputEl.files.item(0);
      }
    });

    this.csvService.importCsv(this.selectedContractId, csvFile).subscribe(
      response => {
        if (response.type === HttpEventType.UploadProgress) {
          // Compute and show the % done:
          this.percentDone = Math.round((100 * response.loaded) / response.total);
          this.isUploading = false;
        } else if (response.type === HttpEventType.Response) {
          this.isImporting = false;
        }
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
        this.isUploading = false;
        this.isImporting = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/import/csv/import-csv.component.ts